<div>
  <div mat-dialog-content>
    <form>
      <div class="row m-t-20">
        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>SELECCIONAR ENTIDAD</mat-label>
            <mat-select (selectionChange)="onEntidadSeleccionada($event.value)" [(value)]="entidadSeleccionada">
              <mat-option *ngFor="let entidad of entidades" [value]="entidad">
                {{ entidad.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div [hidden]="!entidadSeleccionada" class="col-xl-6 col-lg-6 col-md-6 col-sm-12 mb-2">
          <mat-form-field appearance="outline" class="example-full-width">
            <mat-label>SELECCIONAR MUNICIPIO</mat-label>
            <mat-select (selectionChange)="onMunicipioSeleccionado($event.value)" [(value)]="municipioSeleccionado">
              <mat-option *ngFor="let municipio of municipios" [value]="municipio">
                {{ municipio.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
          <button (click)="limpiarSeleccion()"
                  mat-flat-button
          >LIMPIAR SELECCION
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
<div [hidden]="!isDataLoaded" class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card">
      <div class="materialTableHeader">
        <div class="left">
          <ul class="header-buttons-left ms-0">
            <li class="tbl-search-box">
              <label><i class="material-icons search-icon">search</i></label>
              <input
                #filter
                aria-autocomplete="none"
                aria-label="Search box" autocomplete="nope" class="browser-default search-field" placeholder="BUSCAR"
                type="text">
            </li>
          </ul>
        </div>
      </div>

      <div class="body overflow-auto">
        <div class="responsive_table">
          <table [dataSource]="dataSource" class="mat-cell advance-table" mat-table matSort>

            <ng-container matColumnDef="id">
              <mat-header-cell *matHeaderCellDef mat-sort-header>ID</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.idCP}}">{{ row.idCP }}</mat-cell>
            </ng-container>


            <ng-container matColumnDef="cp">
              <mat-header-cell *matHeaderCellDef mat-sort-header>CODIGO POSTAL</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.codigoPostal}}"><span
                class="mobile-label">Codigo postal:</span>{{ row.codigoPostal }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="entidad">
              <mat-header-cell *matHeaderCellDef mat-sort-header>ENTIDAD</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.nombreEntidad}}"><span
                class="mobile-label">Entidad:</span>{{ row.nombreEntidad }}
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="municipio">
              <mat-header-cell *matHeaderCellDef mat-sort-header>MUNICIPIO</mat-header-cell>
              <mat-cell *matCellDef="let row" matTooltip="{{row.nombreMunicipio}}"><span
                class="mobile-label">Municipiol:</span>{{ row.nombreMunicipio }}
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
            </mat-row>
          </table>
          <!-- Loading spinner -->
          @if (data.isTblLoading) {
            <div class="tbl-spinner">
              <mat-progress-spinner color="primary" [diameter]="40" mode="indeterminate">
              </mat-progress-spinner>
            </div>
          }
          @if (!data.isTblLoading) {
            <div class="no-results" [style.display]="dataSource.renderedData.length === 0 ? '' : 'none'">
              Sin datos
            </div>
          }
          <mat-paginator [length]="dataSource.filteredData.length" [pageIndex]="0" [pageSizeOptions]="[5, 10, 25, 100]"
                         [pageSize]="10">
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>


